import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowDoubleRight = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M5.706 5.292a1 1 0 0 0-1.413 1.413L9.593 12l-5.3 5.295a.998.998 0 1 0 1.413 1.412l6.006-6a.998.998 0 0 0 0-1.413L5.707 5.292Z", fill: color }),
        React.createElement("path", { d: "M13.7 5.292a1 1 0 0 0-1.412 1.413l5.3 5.295-5.3 5.295a.998.998 0 1 0 1.413 1.412l6.006-6a.998.998 0 0 0 0-1.413l-6.006-6.002Z", fill: color })));
};
export default factorySvgIcon(SvgArrowDoubleRight);
//# sourceMappingURL=SvgArrowDoubleRight.js.map